import { SliderButton } from '@typeform/embed-react'
import styled from 'styled-components'

export const StyledSliderButton = styled(SliderButton)`
  height: 0px;
`
